import { UploadedFile } from "./uploaded-file.model";
import type { PlasticsMoldPlacement } from './plastics-mold-checkup.model';

export interface PlasticsMoldFamily {
	id: string;
	createdOn: Date;
	createdById: string;
	name: string;
	description: string;
	/** Shared machine × arm layout for every mold in this family. */
	armAllocations: PlasticsMoldArmAllocation[];
}

export interface PlasticsMold {
	id: string;
	name: string;
	moldFamilyId: string;
	createdOn: Date;
	createdById: string;
	updatedOn: Date;
	updatedById: string;
	customerId: string;
	serialNumber: number | null;
	status: PlasticsMoldStatus;
	totalCycleCount: number;
	files: UploadedFile[];
	checkupInterval?: number | null;
	lastCheckupCycleCount?: number;
	/** Latched until a completed checkup; does not change the mounted mold's status. */
	checkupOnNextRemoval?: boolean;
	placement?: PlasticsMoldPlacement | null;
	openCheckupId?: string | null;
}

export function formatPlasticsMoldSerialNumber(serialNumber: number | null | undefined): string {
	return serialNumber == null ? '' : serialNumber.toString().padStart(4, '0');
}

export interface PlasticsMoldArmAllocation {
	id: string;
	machineId: string;
	armId: string;
	armSpace: PlasticsMoldArmSpace
}

export enum PlasticsMoldArmSpace {
	Half = 'Half',
	Quarter = 'Quarter',
	Third = 'Third',
	Full = 'Full',
	Eighth = 'Eighth',
	Sixteenth = 'Sixteenth'
}

export const plasticsMoldArmSpaceValueDict: Record<PlasticsMoldArmSpace, number> = {
	[PlasticsMoldArmSpace.Half]: 0.5,
	[PlasticsMoldArmSpace.Quarter]: 0.25,
	[PlasticsMoldArmSpace.Third]: 0.3333,
	[PlasticsMoldArmSpace.Full]: 1,
	[PlasticsMoldArmSpace.Eighth]: 0.125,
	[PlasticsMoldArmSpace.Sixteenth]: 0.0625
} as const
export const plasticsMoldArmSpaceFractionDict: Record<PlasticsMoldArmSpace, string> = {
	[PlasticsMoldArmSpace.Half]: '1/2',
	[PlasticsMoldArmSpace.Quarter]: '1/4',
	[PlasticsMoldArmSpace.Third]: '1/3',
	[PlasticsMoldArmSpace.Full]: 'Full',
	[PlasticsMoldArmSpace.Eighth]: '1/8',
	[PlasticsMoldArmSpace.Sixteenth]: '1/16'
} as const

export enum PlasticsMoldStatus {
	Active = "Active",
	NeedsCheckup = "Needs checkup",
	Repair = "Repair",
	Shipped = "Shipped",
	Retired = "Retired",
}

/**
 * automatically build roto schedule
 * mold ownership
 * mold shipment/history
 * library of all molds current/past
 * mold repair
 * cycle counts for preventative maintenance
 */
